import DataAccessObject from '../../../../core/DAL/DAO/DataAccessObject';
import DistributionPermissionsDAOProperties from './DistributionPermissionsDAOProperties';

export default class DistributionPermissionsDAO extends DataAccessObject {
	constructor($resource, appNotificationsInterceptor, distributionBundlesDAOProperties) {
		super($resource, appNotificationsInterceptor, distributionBundlesDAOProperties);
	}
}

DistributionPermissionsDAO.META = {
	name: 'DistributionPermissionsDAO'
};

DistributionPermissionsDAO.$inject = ['$resource', 'appNotificationsInterceptor', DistributionPermissionsDAOProperties.META.name];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/DAO/permissions/DistributionPermissionsDAO.js